module.exports = __webpack_public_path__ + "static/media/1v1-active.1ef9f75d.svg";